module.exports = __webpack_public_path__ + "img/hand-landing.4979acb0.jpg";